module.exports = tribe.common.elements;